import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SectionsService } from '../../../services/sections.service';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../shared/authorization/authorization.service';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { SharedDataService } from '../../../shared/services/shared-data-service';
import { ParticipantLeadsListComponent } from '../../participant-leads-list/participant-leads-list.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AuthorizeButtonDirective } from '../../../shared/authorization/authorizeButton.directive';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { AutoFocusHeaderDirective } from '../../../shared/directives/auto-focus-header.directive';
import { LookupValueItem } from '../../../interfaces/lookup.interface';

@Component({
  selector: 'ppl-referral-list',
  standalone: true,
  imports: [
    ListTableComponent,
    NzIconModule,
    NzButtonModule,
    RouterModule,
    AuthorizeButtonDirective,
    ButtonComponent,
    AutoFocusHeaderDirective
  ],
  templateUrl: './referral-list.component.html',
  styleUrl: './referral-list.component.css',
})
export class ReferralListComponent extends ParticipantLeadsListComponent implements OnInit{
  override sharedDataKey: string = STATIC_DATA.SHARED_REFERRAL_DATA;
  override pageId: string = PAGE_CONSTANTS.PARTICPANT_REFERRAL_GRID_PAGE;
  contactStsReasonLkpList: LookupValueItem[] = [];
  showSelectAction = false;
  applicationStatusSearchValues: LookupValueItem[] = [];

  constructor(
    router: Router,
    sectionService: SectionsService,
    referralDataService: ReferralDataService,
    sharedDataService: SharedDataService,
    authUtility: AuthorizationUtility,
    authService: AuthorizationService,
    userService: UserService,
    private leadDetailsService: LeadDetailsService,
    private storageService: StorageService
  ) {
    super(
      router,
      sectionService,
      referralDataService,
      sharedDataService,
      userService,
      authUtility,
      authService,
    );
  }

  override onNewLead(): void {
    this.router.navigate(['/referralLogic']);
    this.sectionService.setFlow('providers');
    this.referralDataService.clearReferrralData();
  }

  override ngOnInit(): void {
    this.contactStsReasonLkpList = this.lookupService.getLookupValue('contact_status_reason_lkp');
    this.applicationStatusSearchValues = this.lookupService.getLookupValue('Referral_Status');
    this.showSelectAction = !this.userService.isInRole(['LDSS Role', 'MCO Admin', 'MCO Super Admin', 'Enrollment Specialist', 'Fulfillment Staff']);
    super.ngOnInit()
  }

  protected override getRoleBasedHiddenActions(): string[] {
    return this.userService.isInRole(['PAVAdmin', 'PAVTraining'])
      ? ['assign_to_user', 'assign_to_me']
      : [];
  }

  onNewReferral() {
    this.router.navigate(['/newReferral']);
    this.sectionService.setFlow('referral');
    this.userService.setLeadEntry('');
    this.referralDataService.clearReferrralData();
    this.storageService.setReferralSource('self');
  }

  override rowClicked(rowDetail: any) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('referral');
    this.sectionService.setFlow('referral');
    this.referralDataService.clearReferrralData();
    this.userService.setSelectedLead(rowDetail.referral_participant_id);
    if (rowDetail.application_stage_lkp == 'Copied from Lead' || rowDetail.application_status_lkp === 'In Progress') {
    this.leadDetailsService.fetchLeadDetailsApi('referral', program?.program_code ??  '', rowDetail.referral_participant_id).subscribe((data:any)=>{
      this.referralDataService.setReferralDetails(data.responsedata);
      setTimeout(() => {
        this.storageService.setReferralId(data.responsedata?.infoData?.referralId);
        this.storageService.setTrackingNumber(data.responsedata?.infoData?.trackingNumber);
        this.router.navigate(['/newReferral']);
      }, 200);
    })
    } else {
      setTimeout(() => {
        this.router.navigate(['/home/referralList/referralDetails/']);
      }, 200)
    }
   
  }
}